import { useContext } from 'react';
import { SubscriptionDetailsContext } from '../context/SubscriptionDetailsContext.js';

/**
 * Custom hook to normalize the subscription status from context.
 *
 * @returns {string} - The normalized subscription status: 'active' or 'not active'.
 */
export default function useNormalizedSubscriptionStatus() {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const status = subscriptionDetails?.subscriptionStatus;

  if (status === 'unsubscribed') {
    return 'not active';
  } else if (!status && subscriptionDetails?.data?.isCancelled === true) {
    return 'active';
  } else if (status?.toLowerCase() === 'active') {
    return 'active';
  }

  return 'not active';
}
